import { render } from "./statistics-table.vue?vue&type=template&id=24b91aea&scoped=true"
import script from "./statistics-table.vue?vue&type=script&lang=ts"
export * from "./statistics-table.vue?vue&type=script&lang=ts"

import "./statistics-table.vue?vue&type=style&index=0&id=24b91aea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24b91aea"

export default script